import { jiraSpaPageContainerResource } from '@atlassian/jira-router-resources-spa-page-container/src/jiraSpaPageContainerResource.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';
import { getBannerResources } from './banners.tsx';

export const getSpaResources = (): RouteResource[] => [
	resourceWithCondition2(() => fg('jpx-463-spa-relay-query'), jiraSpaPageContainerResource),
	...getBannerResources(),
];
